import { useDispatch } from 'react-redux';

import { ClickToCallAgentClosedInputDto, ClickToCallAgentClosedOutputDto } from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchClickToCallAgentClosed = (): UseFetchHookOutput<
	Omit<ClickToCallAgentClosedInputDto, 'metadata'>,
	ClickToCallAgentClosedOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<ClickToCallAgentClosedInputDto, ClickToCallAgentClosedOutputDto>({
		operationKey: 'clickToCallAgentClosed',
		onSuccess: (res) => {
			if (res.data) {
				dispatch(saveSuccessServiceResponse({ clickToCallAgentClosed: res.data }));
			}
		},
	});
};
